import { render, staticRenderFns } from "./EditProductos.vue?vue&type=template&id=27f9defe&scoped=true&"
import script from "./EditProductos.vue?vue&type=script&lang=js&"
export * from "./EditProductos.vue?vue&type=script&lang=js&"
import style0 from "./EditProductos.vue?vue&type=style&index=0&id=27f9defe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9defe",
  null
  
)

export default component.exports